import React, { Component } from "react";
import "./css/interiorMobile.css";

import BattenButton from "./src/Button_Batten.png";
import FloorButton from "./src/Button_Floor.png";
import ShowResult from "./src/show_result.png";
import ButtonHideInfo from "./src/select-down-img.png";
import ButtonShowInfo from "./src/select-up-img.png";
import ArrowResult from "./src/arrow_result.png";

import ResultListBatten from "./ResultListBattenMobile";
import ResultListFloor from "./ResultListFloorMobile";

import PanAndZoom from "./PanAndZoom";
import ResultScreenMobile from "./ResultScreenMobile";
import TableInformation from "./tableInformationMobile";
import CalculateBatten from "../calculator/batten/calBatten";
import CalculateFloor from "../calculator/floor/calFloor";
import EcommerceMobile from "../ecommerce/EcommerceMobile";

import Axios from "axios";

class interiorMobile extends Component {
  state = {
    currentMenuSelect: "batten",
    currentEcomSelect: "batten",
    currentBatten: [],
    currentFloor: [],
    dataBatten: [],
    dataFloor: [],
    currentBattenForCal: [],
    currentFloorForCal: [],

    ResultScreen: false,
    Information: false,
    Calculate: false,
    Ecommerce: false,

    dimensionsWidth: null,
    dimensionsHeight: null,
    dimensionsOrientation: "not decided yet",
  };

  onSelectMenu = (value) => {
    this.setState({ currentMenuSelect: value });
  };

  onSelectBatten = (value) => {
    this.setState({ currentBatten: { ...value } });
    this.setState({ currentBattenForCal: { ...value } });
  };

  onSelectBattenFromSelect = (value) => {
    console.log("onSelectBattenFromSelect ", value);
    const data = this.state.dataBatten.find(
      (xData) => Number(xData.id) === value
    );

    this.setState({ currentBattenForCal: { ...data } });

    if (data.imagelink === "NoImage") {
      const result = this.state.dataBatten.find(
        (xData) =>
          Number(xData.track) === Number(data.track) &&
          xData.imagelink !== "NoImage"
      );

      if (result != null) {
        const newData = { ...data, imagelink: result.imagelink };
        this.setState({ currentBatten: { ...newData } });
      }
    } else {
      this.setState({ currentBatten: { ...data } });
    }
  };

  onSelectFloor = (value) => {
    this.setState({ currentFloor: { ...value } });
    this.setState({ currentFloorForCal: { ...value } });
  };

  onSelectFloorFromSelect = (value) => {
    console.log("onSelectFloorFromSelect ", value);
    const data = this.state.dataFloor.find(
      (xData) => Number(xData.id) === value
    );

    this.setState({ currentFloorForCal: { ...data } });

    if (data.imagelink === "NoImage") {
      const result = this.state.dataFloor.find(
        (xData) =>
          Number(xData.track) === Number(data.track) &&
          xData.imagelink !== "NoImage"
      );

      if (result != null) {
        const newData = { ...data, imagelink: result.imagelink };
        this.setState({ currentFloor: { ...newData } });
      }
    } else {
      this.setState({ currentFloor: { ...data } });
    }
  };

  onResultScreen = () => {
    const prev = this.state.ResultScreen;
    this.setState({ ResultScreen: !prev });
  };

  onHideResultScreen = () => {
    this.setState({ ResultScreen: false });
  };

  onInformation = () => {
    const prev = this.state.Information;
    this.setState({ Information: !prev });
  };

  onCalculate = () => {
    const prev = this.state.Calculate;
    this.setState({ Calculate: !prev });

    this.setState({ Information: false });
  };

  onEcommerce = (value) => {
    if (value !== "") this.setState({ currentEcomSelect: value });

    const prev = this.state.Ecommerce;
    this.setState({ Ecommerce: !prev });
  };

  async componentDidMount() {
    const batten = await Axios.get(
      "https://www.shera.com/AR/api/?sqli=id,track,name,class,striped,color,size,width,numpersqm,imagelink,iconlink&table=battens"
    );

    this.setState({ dataBatten: batten.data });

    batten.data.map((resultBatten) => {
      if (resultBatten.id === "1") {
        this.setState({ currentBatten: { ...resultBatten } });
        this.setState({ currentBattenForCal: { ...resultBatten } });
      }
      return null;
    });

    const floor = await Axios.get(
      "https://www.shera.com/AR/api/?sqli=id,track,name,class,striped,color,size,width,numpersqm,imagelink,iconlink&table=floors"
    );

    this.setState({ dataFloor: floor.data });

    floor.data.map((result) => {
      if (result.id === "1") {
        this.setState({ currentFloor: { ...result } });
        this.setState({ currentFloorForCal: { ...result } });
      }
      return null;
    });

    this.setState({ dimensionsHeight: this.container.offsetHeight });
    this.setState({ dimensionsWidth: this.container.offsetWidth });

    // console.log(Number(this.container.offsetHeight));
    // console.log(Number(this.container.offsetWidth));
    // console.log(
    //   Number(this.container.offsetWidth) / Number(this.container.offsetHeight)
    // );

    if (
      Number(this.container.offsetWidth) / Number(this.container.offsetHeight) >
      1.498829
    ) {
      this.setState({ dimensionsOrientation: "width" });
    } else {
      this.setState({ dimensionsOrientation: "height" });
    }
  }

  render() {
    return (
      <>
        <div className="interior-mobile-main">
          <div
            className="interior-mobile-header"
            onClick={this.onHideResultScreen}
          >
            <p className="interior-mobile-header-text">พื้นที่ต่อเติม</p>
          </div>
          <div
            className="interior-mobile-body"
            ref={(el) => (this.container = el)}
          >
            <PanAndZoom
              currentBatten={this.state.currentBatten.imagelink}
              currentFloor={this.state.currentFloor.imagelink}
              dimensionsOrientation={this.state.dimensionsOrientation}
            />

            <div
              className="interior-mobile-resultIcon"
              onClick={this.onResultScreen}
            >
              <img
                className="interior-pc-resultArrow-image"
                style={{ paddingTop: "15px", paddingBottom: "20px" }}
                src={ArrowResult}
                alt=""
              />
              <img
                className="interior-mobile-resultIcon-image"
                src={ShowResult}
                alt=""
              />
              <p className="interior-mobile-resultIcon-text">แสดงผลลัพท์</p>
            </div>

            <div className="interior-mobile-information">
              <div className="interior-mobile-information-button-container">
                <img
                  className="interior-mobile-information-button"
                  src={this.state.Information ? ButtonHideInfo : ButtonShowInfo}
                  alt=""
                  onClick={this.onInformation}
                />
              </div>

              <div
                className={
                  this.state.Information
                    ? "interior-mobile-information-container-show"
                    : "interior-mobile-information-container-hide"
                }
              >
                <TableInformation
                  currentMenuSelect={this.state.currentMenuSelect}
                  currentFloor={this.state.currentFloor}
                  currentBatten={this.state.currentBatten}
                  dataFloor={this.state.dataFloor}
                  dataBatten={this.state.dataBatten}
                  onCalculate={this.onCalculate}
                  onEcommerce={this.onEcommerce}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="interior-mobile-footer">
          <div className="interior-mobile-footer-menu-main-container">
            <div
              className={
                this.state.currentMenuSelect === "batten"
                  ? "interior-mobile-footer-menu-container-show"
                  : "interior-mobile-footer-menu-container-hide"
              }
              onClick={() => this.onSelectMenu("batten")}
            >
              <img
                className={
                  this.state.currentMenuSelect === "batten"
                    ? "interior-mobile-footer-menu-batten-select"
                    : "interior-mobile-footer-menu-batten-unselect"
                }
                src={BattenButton}
                alt="Button Batten"
              />
              <div
                className={
                  this.state.currentMenuSelect === "batten"
                    ? "interior-mobile-footer-menu-line-batten-select"
                    : "interior-mobile-footer-menu-line-batten-unselect"
                }
              />
            </div>
            {/* <div className="interior-mobile-footer-menu-line"></div> */}
            <div
              className={
                this.state.currentMenuSelect === "batten"
                  ? "interior-mobile-footer-menu-container-hide"
                  : "interior-mobile-footer-menu-container-show"
              }
              onClick={() => this.onSelectMenu("floor")}
            >
              <img
                className={
                  this.state.currentMenuSelect === "batten"
                    ? "interior-mobile-footer-menu-floor-unselect"
                    : "interior-mobile-footer-menu-floor-select"
                }
                src={FloorButton}
                alt="Button Batten"
              />
              <div
                className={
                  this.state.currentMenuSelect === "floor"
                    ? "interior-mobile-footer-menu-line-floor-select"
                    : "interior-mobile-footer-menu-line-floor-unselect"
                }
              />
            </div>
          </div>
          <div className="interior-mobile-footer-main-list-container">
            <div
              className={
                this.state.currentMenuSelect === "batten"
                  ? "interior-mobile-footer-list-container-show"
                  : "interior-mobile-footer-list-container-hide"
              }
            >
              <ResultListBatten
                onSelect={this.onSelectBatten}
                current={this.state.currentBatten}
              />
            </div>
            <div
              className={
                this.state.currentMenuSelect === "batten"
                  ? "interior-mobile-footer-list-container-hide"
                  : "interior-mobile-footer-list-container-show"
              }
            >
              <ResultListFloor
                onSelect={this.onSelectFloor}
                current={this.state.currentFloor}
              />
            </div>
          </div>
        </div>
        <div
          className={
            this.state.ResultScreen
              ? "interior-mobile-resultScreen-container-show"
              : "interior-mobile-resultScreen-container-hide"
          }
        >
          <ResultScreenMobile
            currentBatten={this.state.currentBatten}
            currentFloor={this.state.currentFloor}
            onEcommerce={this.onEcommerce}
            onClose={this.onResultScreen}
            show={this.state.ResultScreen}
          />
        </div>

        <div>
          <EcommerceMobile
            currentProduct={
              this.state.currentEcomSelect === "batten"
                ? this.state.currentBatten.id
                : this.state.currentFloor.id
            }
            currentEcomSelect={this.state.currentEcomSelect}
            status={this.state.Ecommerce}
            onEcommerce={this.onEcommerce}
          />
        </div>

        <div
          className={
            this.state.Calculate
              ? "interior-mobile-calculate-show"
              : "interior-mobile-calculate-hide"
          }
        >
          {this.state.currentMenuSelect === "batten" ? (
            <CalculateBatten
              onClose={this.onCalculate}
              dataBatten={this.state.dataBatten}
              currentBatten={this.state.currentBattenForCal}
              onSelect={this.onSelectBattenFromSelect}
            />
          ) : (
            <CalculateFloor
              onClose={this.onCalculate}
              dataFloor={this.state.dataFloor}
              currentFloor={this.state.currentFloorForCal}
              onSelect={this.onSelectFloorFromSelect}
            />
          )}
        </div>
        <div className="interior-mobile-header-logo" />
      </>
    );
  }
}

export default interiorMobile;
